export const PROFILE_SETUP_REQUIRED = "profile.setup_required";

/** @param {{ type?: string } | null | undefined} notification */
export function isProfileSetupRequiredNotification(notification) {
  return notification?.type === PROFILE_SETUP_REQUIRED;
}

/** @param {{ role?: string, profileActive?: boolean } | null | undefined} user */
export function isApplicantProfileSetupComplete(user) {
  if (user?.role !== "applicant") return true;
  return user?.profileActive === true;
}

/**
 * Whether the full notifications page may show a Dismiss control.
 * @param {{ type?: string, dismissible?: boolean, isActive?: boolean, dismissedAt?: string, actionedAt?: string } | null | undefined} notification
 */
export function isNotificationDismissible(notification) {
  if (notification?.dismissible === false) return false;
  if (isProfileSetupRequiredNotification(notification)) return false;
  const isActive = notification?.isActive !== false && !notification?.dismissedAt && !notification?.actionedAt;
  return isActive;
}
